import { useState } from "react"
import { Loader, Pause, Play } from "react-feather"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { useIsBuffering, useIsPlaying } from "./state"

export const PlayButton: React.FC<{ children?: undefined }> = ({}) => {
  const { t } = useTranslation("articles")

  const [hasBeenClickedOnce, setHasBeenClicked] = useState(false)

  const [isPlaying, setIsPlaying] = useIsPlaying()
  const [isBuffering] = useIsBuffering()

  let message = hasBeenClickedOnce ? "buttons.play" : "buttons.listen"
  let Icon = Play

  if (isPlaying) {
    message = "buttons.pause"
    Icon = Pause
  }

  if (isBuffering) {
    message = "buttons.buffering"
    Icon = Loader
  }

  return (
    <button
      className={clsx(
        "flex items-center justify-center",
        "space-x-2 rounded p-2 py-1.5",
        "font-display font-semibold",
        "bg-primary-500 text-white dark:bg-secondary-500 dark:text-black",
        "hover:bg-primary-700 dark:hover:bg-secondary-200",
        "focus:bg-primary-700 dark:focus:bg-secondary-200",
      )}
      onClick={() => {
        setHasBeenClicked(true)
        setIsPlaying(!isPlaying)
      }}
    >
      <Icon
        className={clsx({ "animate-spin": isBuffering })}
        strokeWidth={2}
        size={20}
      />
      <span
        className={clsx("pr-2 text-sm md:text-base", {
          "sr-only": hasBeenClickedOnce,
        })}
      >
        {t(message)}
      </span>
    </button>
  )
}
